/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listBlobs.defs.js'
export { main as default } from './listBlobs.defs.js'
